import React, { useCallback, useEffect, useState } from 'react';
import './GoldMembership.scss';
import { EmptyState } from '../../commons';
import { Loader, Table } from '../../../UiKit';
import { InvalidSearchImg } from '../../../images/images';
import { userModel } from '../../../api';
import { getMembershipTableTemplate } from './utils';

const tableHeadings = [
  { name: 'Unlock Date', key: 1 },
  { name: 'Order ID', key: 2 },
  { name: 'Restaurant', key: 3 },
  { name: 'Savings', key: 4 },
];

export const GoldMembership = ({ userId = null, orderId = null }) => {
  const [membershipData, setMembershipData] = useState(null);
  const [error, setError] = useState(null);

  const getMembershipData = useCallback(() => {
    let queryStrings = {};
    queryStrings['user_id'] = userId;
    queryStrings['order_id'] = orderId;
    userModel
      .getGoldDetails(queryStrings)
      .then((response) => {
        if (!response || response?.isError) return setError(response);
        setMembershipData(response);
      })
      .catch((err) => {
        setError(err);
      });
  }, [userId, orderId]);

  useEffect(() => {
    getMembershipData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getmembershipRows = (visits) => {
    const rowsData = [];
    visits &&
      visits.map((visit) => {
        const goldTableObj = getMembershipTableTemplate(visit);
        rowsData.push(goldTableObj);
        return true;
      });
    return rowsData;
  };

  const getTableData = (visits) => {
    if (!visits) return null;
    const tableData = {
      headings: tableHeadings,
      rows: getmembershipRows(visits),
    };
    return tableData;
  };

  if (!membershipData && !error) {
    return <Loader />;
  }
  if (error) {
    return (
      <EmptyState
        img={InvalidSearchImg}
        heading={error?.message || 'No data available!'}
        isPop={true}
      />
    );
  }
  return (
    <div className='popContent modalContent goldMembership'>
      {!!membershipData?.basic && (
        <div className='planDetails'>
          <div className='plans'>
            <div className='text'>Plan</div>
            <div className='value'>{membershipData.basic?.plan_details}</div>
          </div>
          <div className='plans'>
            <div className='text'>Membership ID</div>
            <div className='value'>{membershipData.basic?.membership_id}</div>
          </div>
          <div className='plans'>
            <div className='text'>Validity</div>
            <div className='value'>{membershipData.basic?.validity}</div>
          </div>
          <div className='plans'>
            <div className='text'>Unlocks left</div>
            <div className='value'>{membershipData.basic?.unlocks_left}</div>
          </div>
          <div className='plans'>
            <div className='text'>Plan price</div>
            <div className='value'>{membershipData.basic?.plan_cost}</div>
          </div>
        </div>
      )}
      <div className='ordersDetails'>
        <Table tableData={getTableData(membershipData?.visits)} />
      </div>
    </div>
  );
};
